import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaTrophy } from 'react-icons/fa';
import BadgeIcon from './BadgeIcon';

const LevelUpModal = ({ show, levelUp, onClose }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (show) {
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 1200);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [show]);

  if (!levelUp) return null;

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static">
      <Modal.Body className="text-center py-5 px-4 bg-gradient-to-br from-purple-50 via-pink-50 to-yellow-50">
        <div className={`transition-transform duration-700 ${animate ? 'scale-110' : 'scale-100'}`}>
          <div
            className="mx-auto mb-4 w-24 h-24 rounded-2xl flex items-center justify-center shadow-lg"
            style={{ backgroundColor: `${levelUp.badge_color}22`, color: levelUp.badge_color }}
          >
            <BadgeIcon badgeKey={levelUp.badge_key} color={levelUp.badge_color} size={48} />
          </div>
          <FaTrophy className="text-yellow-500 mb-3" size={36} />
          <h4 className="font-bold text-gray-800 mb-2">Level Up!</h4>
          <p className="text-lg font-semibold text-purple-700 mb-1">{levelUp.level_name}</p>
          <p className="text-gray-600 mb-0">{levelUp.badge_label}</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center pb-4">
        <Button
          onClick={onClose}
          className="border-1 border-purple-600 bg-white text-purple-600 font-semibold rounded-xl px-5"
        >
          Celebrate!
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LevelUpModal;
